import { Config, AuthHeader } from "../helpers/Config";
import { UserService } from "./UserService";


let user = JSON.parse(localStorage.getItem('user'));
let activeAccount = localStorage.getItem('userActiveAccount') || (user ? user.login : "");

export const TransferOptionService = {

    /**
     * [DEPOSIT] 
     * 
     * [Get Options & History]
     * @function Page 
     * 
     * [Get History]
     * @function History 
     * 
     * [Get Options]
     * @function Options 
     * 
     * [Get Option Page Detail]
     * @function OptionPage 
     */
    Deposit: {
        /**
         * [Get Options & History]
         * @function Page 
         */
        Page() {

            TransferOptionService.Common.Account();

            var requestOptions = {
                method: 'POST',
                headers: AuthHeader(),
                body: JSON.stringify({ login: activeAccount })
            }

            return TransferOptionService.Common.Fetch(Config.service.transferOption.deposit.page, requestOptions);
        },
        /**
         * [Get History]
         * @function History 
         */
        History(period) {

            var requestOptions = {
                method: 'post',
                headers: AuthHeader(),
                body: JSON.stringify({ period: period })
            }

            return TransferOptionService.Common.Fetch(Config.service.transferOption.deposit.history, requestOptions);

        },
        /**
         * [Get Options]
         * @function Options 
         */
        Options() {

            TransferOptionService.Common.Account();

            var requestOptions = {
                method: 'POST',
                headers: AuthHeader(),
                body: JSON.stringify({ login: activeAccount })
            }

            return TransferOptionService.Common.Fetch(Config.service.transferOption.deposit.options, requestOptions);

        },
        /**
         * [Get Option Page Detail]
         * @function OptionPage 
         * @param {string} url Transfer Option URL
         */
        OptionPage(url) {

            TransferOptionService.Common.Account();

            var requestOptions = {
                method: 'POST',
                headers: AuthHeader(),
                body: JSON.stringify({ login: activeAccount, transferOptionUrl: url })
            }

            return TransferOptionService.Common.Fetch(Config.service.transferOption.deposit.optionPage, requestOptions);

        }
    },

    /**
     * [WITHDRAWAL]
     * 
     * [Get Options & History]
     * @function Page 
     * 
     * [Get History]
     * @function History
     *  
     * [Get Options]
     * @function Options 
     * 
     * [Get Option Page Detail]
     * @function OptionPage 
     */
    Withdrawal: {
        /**
         * [Get Options & History]
         * @function Page 
         */
        Page() {

            TransferOptionService.Common.Account();

            var requestOptions = {
                method: 'POST',
                headers: AuthHeader(),
                body: JSON.stringify({ login: activeAccount })
            }

            return TransferOptionService.Common.Fetch(Config.service.transferOption.withdrawal.page, requestOptions);

        },
        /**
         * [Get History]
         * @function History
         */
        History(period) {

            var requestOptions = {
                method: 'post',
                headers: AuthHeader(),
                body: JSON.stringify({ period: period })
            }

            return TransferOptionService.Common.Fetch(Config.service.transferOption.withdrawal.history, requestOptions);

        },
        /**
         * [Get Options]
         * @function Options
         */
        Options() {

            TransferOptionService.Common.Account();

            var requestOptions = {
                method: 'POST',
                headers: AuthHeader(),
                body: JSON.stringify({ login: activeAccount })
            }

            return TransferOptionService.Common.Fetch(Config.service.transferOption.withdrawal.options, requestOptions);

        },
        /**
         * [Get Option Page Detail]
         * @function OptionPage
         * @param {string} url Transfer Option URL
         */
        OptionPage(url) {

            TransferOptionService.Common.Account();

            var requestOptions = {
                method: 'POST',
                headers: AuthHeader(),
                body: JSON.stringify({ login: activeAccount, transferOptionUrl: url })
            }

            return TransferOptionService.Common.Fetch(Config.service.transferOption.withdrawal.optionPage, requestOptions);

        }
    },

    /**
     * [INTERNAL_TRANSFER]
     * 
     * [Get History]
     * @function History
     */
    InternalTransfer: {
        /**
         * [Get Options & History]
         * @function Page 
         * @param {string} period 
         */
        Page(period) {

            var requestOptions = {
                method: 'post',
                headers: AuthHeader(),
                body: JSON.stringify({ period: period })
            }

            return TransferOptionService.Common.Fetch(Config.service.transferOption.internalTransfer.page, requestOptions);

        },
        /**
         * [Get History]
         * @function History
         * @param {string} period 
         */
        History(period) {

            var requestOptions = {
                method: 'post',
                headers: AuthHeader(),
                body: JSON.stringify({ period: period })
            }

            return TransferOptionService.Common.Fetch(Config.service.transferOption.internalTransfer.history, requestOptions);

        }
    },
    /**
     * [COMMON]
     * @function Account
     * @function Fetch
     */
    Common: {

        Account() {
            user = JSON.parse(localStorage.getItem('user'));
            activeAccount = localStorage.getItem('userActiveAccount') || user.login;
        },
        Fetch(url, requestOptions) {

            return fetch(url, requestOptions)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    } 
                    else if (response.status === 401) {
                        UserService.Logout();

                        window.location.reload();
                    }
                    else {
                        throw new Error();
                    }
                }).then((json) => {

                    return json;

                }).catch(function (error) {

                    
                    if (error.toString() === "TypeError: Failed to fetch")
                        


                    return false;
                });
        }
    }
}
